import { AccountType } from "component-library";
import { MediaRequestType } from "shared-types";
import { i18n } from "i18n";
import {
  FilterControlType,
  FilterType,
  IFilterConfig,
  ISetupFilterConfigParams,
} from "./withSelfTapeRequestNotificationsFilter.config";

export function prepareFilterConfig(
  params: ISetupFilterConfigParams
): IFilterConfig {
  const { t } = i18n;
  const { filterControlTexts, userType, performers } = params;

  const filterConfig: IFilterConfig = {
    [FilterType.DateReceived]: {
      translations: filterControlTexts?.dateReceivedInputPlaceholder ?? "",
      defaultValue: undefined,
      filterControlType: FilterControlType.DatePicker,
      drawerFilterControlType: FilterControlType.DatePicker,
    },
  };

  if (userType === AccountType.Agent) {
    filterConfig[FilterType.Client] = {
      translations: filterControlTexts?.clientDropdownPlaceholder ?? "",
      defaultValue: {},
      filterControlType: FilterControlType.Dropdown,
      drawerFilterControlType: FilterControlType.Checkbox,
      checkboxOptions: prepareClientListOptions(performers),
    };
  }

  filterConfig[FilterType.MediaRequestType] = {
    translations: t("common:mediaRequest.label.requestType"),
    defaultValue: {},
    filterControlType: FilterControlType.Dropdown,
    drawerFilterControlType: FilterControlType.Checkbox,
    checkboxOptions: [
      {
        label: t("common:mediaRequest.label.selfTape"),
        value: String(MediaRequestType.SelfTape),
      },
      {
        label: t("common:mediaRequest.label.audioClip"),
        value: String(MediaRequestType.AudioClip),
      },
    ],
  };

  return filterConfig;
}

export function prepareClientListOptions(
  performers: { id: string; name: string }[]
) {
  return performers.map(({ name, id }) => ({ label: name, value: id }));
}
